export const shadows = {
  outline: 'none',
};
